import { useEffect } from "react";
import { useSidebarStore } from "@/shared/stores/useSidebarStore";

/**
 * Collapses the app nav sidebar for as long as the caller is mounted, restoring
 * the operator's prior choice on unmount. The map is a focused, full-width
 * review surface, so it claims the whole width while it is open.
 */
export const useSidebarCollapse = () => {
  useEffect(() => {
    const prevOpen = useSidebarStore.getState().open;
    useSidebarStore.getState().setOpen(false);
    return () => useSidebarStore.getState().setOpen(prevOpen);
  }, []);
};
